module.exports = __webpack_public_path__ + "static/img/3.99210bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-fr/3.jpg
// module id = XGT6
// module chunks = 1